import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({selector: '[attrColor]'})
export class DynamicDivColorDirective implements OnInit {
  @Input('attrColor') color!: string;
  @Input() attrColorVariable!: string;

  constructor(private readonly el: ElementRef) {
  }

  ngOnInit() {
    if (this.color) {
      this.el.nativeElement.style.setProperty(this.attrColorVariable, this.color);
    }
  }
}
